import { render, staticRenderFns } from "./superClip.vue?vue&type=template&id=02352baa&scoped=true&"
import script from "./superClip.vue?vue&type=script&lang=js&"
export * from "./superClip.vue?vue&type=script&lang=js&"
import style0 from "./superClip.vue?vue&type=style&index=0&id=02352baa&prod&scoped=true&lang=scss&"
import style1 from "./superClip.vue?vue&type=style&index=1&id=02352baa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02352baa",
  null
  
)

export default component.exports